<template>
  <context-menu-fi
    class="fixperience-header-menu-fi"
    :items="isMD ? userActions : mobileActions"
    :flyout-width="375"
    align-context-menu-left
    menu-full-height
    mobile-full-screen
    @context-menu-action="onUserAction"
  >
    <template #mobileItemsTitle>
      <logo-header-fi
        :logo-header="logoHeader"
        :large="$fischer.largeLogo()"
      />
    </template>
    <template #menuToggle="{ isOpen }">
      <div>
        <div class="fixperience-header-menu-fi__toggle-user">
          <icon-fi icon="user" />
          <span class="fi-mx-6 lg:fi-mx-12">{{ $fischer.user.name() }}</span>
          <icon-fi
            :rotate="isOpen ? '180' : '0'"
            icon="chevron-down"
          />
        </div>
        <div class="md:fi-hidden">
          <icon-fi icon="menu" />
        </div>
      </div>
    </template>
    <template #item="{ item }">
      <div class="fi-w-full">
        <div class="fi-hidden md:fi-block">{{ item.title }}</div>
        <div class="fi-flex fi-w-full fi-items-center fi-text-16 md:fi-hidden">
          <icon-fi :icon="item.icon" />
          <div>
            {{ item.title }}
            <div
              v-if="item.action === 'my-account'"
              class="fi-text-grey-dark"
            >
              {{ $fischer.user.name() }}
            </div>
          </div>
          <div class="fi-grow fi-text-end">
            <icon-fi icon="arrow-right" />
          </div>
        </div>
      </div>
    </template>
  </context-menu-fi>
</template>

<script setup lang="ts">
import { ContextMenuFi as contextMenuFiGeneric, IconFi, LogoHeaderFi } from 'atoms';
import { useFixperienceStore } from 'store/fixperience';
import { computed } from 'vue';

import type { ContextMenuItem } from '@/components/atoms/context-menu-fi/ContextMenuFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import { useDict, useFischer } from '@/composables/fischerPlugin';
import type { ImageFieldValue, LinkFieldValue } from '@/sitecoreFieldTypes';

type LinkItem = {
  url?: string;
  icon: string;
} & ContextMenuItem;

const emit = defineEmits<{
  triggerLanguage: [value: void];
  triggerTutorials: [value: void];
}>();

defineProps<{
  logoHeader?: ImageFieldValue;
  homeData?: LinkFieldValue;
}>();

const fischer = useFischer();
const dict = useDict();
const fixperienceStore = useFixperienceStore();
const { isMD } = useBreakpoints();

const ContextMenuFi = contextMenuFiGeneric<LinkItem>;

const userActions: LinkItem[] = [
  {
    title: dict.get('fixperience.Header.Logout'),
    action: 'logout',
    url: fischer.pages.logout().url,
    icon: 'log-out',
    margin: true,
  },
];
if (fischer.pages.myAccount().url) {
  userActions.unshift({
    title: dict.get('fixperience.Header.My-Account'),
    action: 'my-account',
    url: fischer.pages.myAccount().url,
    icon: 'user',
  });
}
const mobileActions = computed<LinkItem[]>(() => [
  {
    title: dict.get('fixperience.Header.Language'),
    action: 'language',
    icon: 'globe',
  },
  ...(fixperienceStore.hasTutorials
    ? [
        {
          title: dict.get('fixperience.Header.Tutorials'),
          action: 'tutorials',
          icon: 'book-open',
        },
      ]
    : []),
  ...userActions,
]);

const onUserAction = (_action: string, item: LinkItem) => {
  if (item.url) {
    window.location.href = item.url;
  } else if (item.action === 'tutorials') {
    emit('triggerTutorials');
  } else if (item.action === 'language') {
    emit('triggerLanguage');
  } else {
    console.error('unhandled item', item);
  }
};
</script>

<style scoped src="./fixperience-header-menu-fi" />
